import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './LeftSidebar.css';

const LeftSidebar = () => {
    const location = useLocation();

    const menuItems = [
        { path: '/pantry', label: 'My Pantry', icon: '🥫' },
        { path: '/shopping-list', label: 'Shopping List', icon: '🛒' },
        { path: '/recipes', label: 'Recipes', icon: '📖' },
        { path: '/meal-planner', label: 'Meal Planner', icon: '📅' },
        { path: '/settings', label: 'Settings', icon: '⚙️' }
    ];

    return (
        <div className="left-sidebar">
            <nav className="sidebar-nav">
                {menuItems.map((item) => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`sidebar-link ${location.pathname === item.path ? 'active' : ''}`}
                    >
                        <span className="sidebar-icon">{item.icon}</span>
                        <span className="sidebar-label">{item.label}</span>
                    </Link>
                ))}
            </nav>
        </div>
    );
};

export default LeftSidebar;
